import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const year = new Date().getFullYear();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <footer className="mt-auto py-3 text-center">
      <div className="container">
        <small className="text-muted">
          &copy; {year} Kathryn E. S. Watt
        </small>
      </div>
    </footer>
  </React.StrictMode>
);
